<template>
  <v-app>
    <v-content class="fill-height">
      <router-view/>
    </v-content>
    <snackbar/>
  </v-app>
</template>

<script>
import Snackbar from '@/components/Snackbar'
export default {
  name: 'Home',
  components: {
    Snackbar
  }
}
</script>
